import React from 'react'
import { Link } from 'react-router-dom';
import ReactPlayer from "react-player"

import './Home.css'

class Home extends React.Component {
  render() {

    var imgRatio = this.props.isMobileSize ? { minHeight: 450, maxHeight: 800 } : { minHeight: 400, maxHeight: 500 };
    var bookBtnText = this.props.isMobileSize ? "Acheter maintenant" : "Acheter maintenant";

    return (
      <div>
        <div id="navigation" className="carousel slide" data-ride="carousel">
          <div className="carousel-inner">
            <div className="carousel-item active">
              <div className="overlay"></div>
              <img className="d-block w-100" style={imgRatio} src="/static/images/home/home-4.png" />
              <div className="carousel-caption d-md-block">
                <h1 className="p-4 font-weight-light text-uppercase">Vivez l'expérience.</h1>
                <div className="pt-5 pb-5 container text-center">
                  <a className="mr-2 btn btn-primary text-center" target="_blank" href="https://resa-bikindoor.deciplus.pro/sp_store.php">{bookBtnText}</a>
                </div>
              </div>
            </div>
            <div className="carousel-item">
              <div className="overlay"></div>
              <img className="d-block w-100" style={imgRatio} src="/static/images/home/home-5.png" />
              <div className="carousel-caption d-md-block">
                <h1 className="p-4 font-weight-light text-uppercase">Rejoignez-nous.</h1>
                <div className="pt-5 pb-5 container text-center">
                  <a className="mr-2 btn btn-primary text-center" target="_blank" href="https://resa-bikindoor.deciplus.pro/sp_store.php">{bookBtnText}</a>
                </div>
              </div>
            </div>
            <div className="carousel-item">
              <div className="overlay"></div>
              <img className="d-block w-100" style={imgRatio} src="/static/images/home/home-6.png" />
              <div className="carousel-caption d-md-block">
                <h1 className="p-4 font-weight-light text-uppercase">Vivez l'instant.</h1>
                <div className="pt-5 pb-5 container text-center">
                  <a className="mr-2 btn btn-primary text-center" target="_blank" href="https://resa-bikindoor.deciplus.pro/sp_store.php">{bookBtnText}</a>
                </div>
              </div>
            </div>
          </div>
          <a className="carousel-control-prev" href="#navigation" role="button" data-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          </a>
          <a className="carousel-control-next" href="#navigation" role="button" data-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
          </a>
        </div>
        <div className="container pt-4 mb-4">
          <div className="text-center">
            <h1 className="text-center text-uppercase font-weight-light">BIK'INDOOR révolutionne l'indoor Cycling</h1>
            <h1 className="bk-blue" style={{ fontVariant: "small-caps" }}>See you on a bike !</h1>
          </div>
        </div>
        <hr />
        <div className="container pt-5">
          <h1 className="bk-blue" style={{ fontVariant: "small-caps" }}>Bik'Indoor c'est...</h1>
          <ul>
            <li className="lead">Un club ouvert 7 jours sur 7, de 7h à 22h, pour s’adapter à tous les rythmes de vie.</li>
            <li className="lead">Un espace de 350 m² entièrement dédié à la performance, au confort et au bien-être.</li>
            <li className="lead">Du matériel haut de gamme, sélectionné pour offrir une expérience d’entraînement optimale.</li>
            <li className="lead">Des sessions sportives uniques, immersives et motivantes.</li>
            <li className="lead">Un lieu pour brûler des calories, renforcer son corps et se dépasser durablement.</li>
            <li className="lead">Un accompagnement complet alliant coaching personnalisé et suivi nutritionnel.</li>
            <li className="lead">Et surtout, un environnement bienveillant, convivial et chaleureux, où chacun trouve sa place et avance à son rythme.</li>
          </ul>
          <div className='player-wrapper mb-2'>
            <ReactPlayer
              className='react-player'
              volume="0.2"
              playing loop url="https://youtu.be/3ZXVRFkvWmo"
              width='100%'
              height='100%'
            />
          </div>
        </div>
        <div className="container pt-5">
          <h1 className="bk-blue" style={{ fontVariant: "small-caps" }}>Parce que votre bien-être est notre priorité...</h1>
          <ul>
            <li className="lead">Nous vous offrons un accompagnement personnalisé, avec un suivi attentif de vos objectifs assuré par nos coachs, à chaque étape de votre parcours.</li>
            <li className="lead">Pour votre confort, le studio met à votre disposition des casiers individuels sécurisés, ainsi qu’un espace sanitaire haut de gamme comprenant des douches individuelles, des sèche-cheveux et des produits de soin.</li>
            <li className="lead">Prolongez l’expérience dans notre espace détente, pensé comme une parenthèse pour vous : prenez le temps de savourer une boisson chaude ou rafraîchissante, de vous poser et de profiter pleinement de ce moment qui vous est dédié.</li>
          </ul>
          <p>
            <img className="m-2 mr-4 p-2 home-detail-image shadow" src="/static/images/home/home-detail-3.jpg" />
            <img className="m-2 mr-4 p-2 home-detail-image shadow" src="/static/images/home/home-detail-4.jpg" />
            <img className="m-2 mr-4 p-2 home-detail-image shadow" src="/static/images/home/home-detail-5.jpg" />
            <img className="m-2 mr-4 p-2 home-detail-image shadow" src="/static/images/home/home-detail-6.jpg" />
          </p>
        </div>
      </div >
    );
  }
}
export default Home;